/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import _ from "underscore";
import util from "util/util.js";


var SurveySiteDetailsViewModel = function(params) {
	var self = this;

  self.survey = params.parent.survey;
  self.showNextTab = params.parent.showNextTab;
  self.showLocationTab = function() { params.parent.showTab('location'); }

  self.details = ko.pureComputed(function() {
    var site = self.survey.sharedSite();

    if(self.survey.program().code == 'egnb' && site && site.metadata) {
      var attributes = [
        { key: "Boxes ID Code", title: "ID" },
        { key: "Type", title: "Type" },
        { key: "Sub-type", title: "Sub-type" },
        { key: "Tree Type", title: "Tree Type" },
        { key: "Date Installed", title: "Date Installed" },
        { key: "Height of box/hollow (m)", title: "Height of box/hollow (m)" },
        { key: "Opening size (mm)", title: "Opening size (mm)" },
        { key: "Locality", title: "Locality" },
        { key: "Tenure", title: "Tenure" },
        { key: "Notes", title: "Notes" }
      ];

      return attributes.map(attr => ({
        title: attr.title,
        value: site.metadata[attr.key]
      }));
    } else {
      return [];
    }
  });
};

ko.components.register('survey-edit-site-details', {
	viewModel: SurveySiteDetailsViewModel,
	template: require('../../templates/survey-edit-site-details.html')
});

export default SurveySiteDetailsViewModel;
